// 用户操作
import USER from './modules/user'
import PRESCRIPTIONDRUG from './modules/prescriptionDrug'

// 药商、药房、药品
import PHARMACYMANAGE from './modules/pharmacyManage'

// 极速开方
import QUICKPRESCRIBE from './modules/quickPrescribe'

// erp
import ERPCHARGEBACK from './modules/erpchargeback.js'

export default {
  PHARMACYMANAGE,
  USER, // 角色账号管理
  PRESCRIPTIONDRUG, // 处方发货及处方订单
  QUICKPRESCRIBE,
  ERPCHARGEBACK
}



// WEBPACK FOOTER //
// ./src/api/index.js